import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Payment, PaymentMethod } from '@ibe/models';
import { HttpClient } from '@angular/common/http';
import { Subscription, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';

import { PaymentService } from '../payment.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
import { SidebarService } from '@ibe/services/ui';
import { INDRABookingPaymentService } from '@ibe.services/booking-payment.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';

import { 
	PRP_PAYMENT_RESULT, 
	PAYMENT_METHOD_PRP_MB_WAY,
	PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE,
	SESSION_VAR_KEY_LANGUAGE,
	DEFAULT_LANGUAGE,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP,
	SESSION_VAR_KEY_MARKET,
	DEFAULT_MARKET
} from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';


@Component({
	selector: 'app-payment-method-mb-way',
	templateUrl: './payment-method-mb-way.indra.component.html',
	styleUrls: ['./payment-method-mb-way.component.scss']
})

export class INDRAPaymentMethodMBWayComponent implements OnInit, OnDestroy {

	public form: FormGroup = this.fb.group({
		// phoneNumberPrefix: [null, [Validators.required]],
		phoneNumber: [null, [Validators.required]],
		accepted_conditions: [null, [Validators.requiredTrue]]
	});
	
	public countryCodeOptions: any[] = [];
	
	allSubs: Subscription[] = [];
	
	merchantAccount;

	@Input()
	hasMilesPayable: boolean;
	
	@Input() 
	displayCovidTermsAndCondition: boolean = false;

	isAlive: boolean = true;
	
  formIsValid$ = this.paymentInfoService.formIsValid;

	/*
	get hasErrorPhoneNumberPrefix(): string {
		return this.form.get('phoneNumberPrefix').invalid && this.form.touched ? 'has-error' : '';
	}
	*/

	get hasErrorClassPhoneNumber(): string {
		return this.form.get('phoneNumber').invalid && this.form.touched ? 'has-error' : '';
	}

	constructor(
		private store: Store<fromStore.State>,
		private paymentInfoService: PaymentService,
		private fb: FormBuilder, 
		private http: HttpClient, 
		private storage: INDRAStorageService,
		private indraPaymentService: INDRAPaymentService,
		private sidebarService: SidebarService,
		private paymentMethodService: INDRABookingPaymentService,
		private ibeAdminService: INDRAIbeAdminService,
		private flightPriceService: INDRAFlightPriceService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService) {

		// this.INDRA_getCountryCodes();
		this.merchantAccount = this.paymentMethodService.INDRA_getPaymentMethodParamValues(PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE, PAYMENT_METHOD_PRP_MB_WAY);
	}

	ngOnInit() {
		const statusSub = this.form.statusChanges.subscribe(value => {
			const isPaymentFormValid = this.paymentInfoService.getFormIsValid();
			if (value === 'VALID') {
				if (!isPaymentFormValid) this.paymentInfoService.setFormIsValid(true);
			} else {
				if (isPaymentFormValid) this.paymentInfoService.setFormIsValid(false);
			}
		});
		this.allSubs.push(statusSub);
		
		const payFormSub = this.paymentInfoService.paymentFormSubmitted.subscribe(value => {
			if (value && value == this.paymentInfoService.paymentMethods.mb_way.id) {
				this.INDRA_submitPayment();
			}
		});
		
		this.allSubs.push(payFormSub);
	}
	
	ngOnDestroy() {
		this.isAlive = false;
		for (const sub of this.allSubs) {
			if (sub) sub.unsubscribe();
		}
	}
	
	/*
	INDRA_getCountryCodes() {
		const URL = './assets/data/indra_country_codes.json';
		const countryCodeSubscription = this.http.get(URL).subscribe(
			(data: any) => {
				const countryCodes = data ? data : [];
				this.countryCodeOptions = countryCodes.map(item => ({
					value: item.prefix.replace('+', ''),
					text: item.countrie + ' ' + item.prefix
				}));
			}
		);
		this.allSubs.push(countryCodeSubscription);
	}
	*/
	
	public INDRA_formErrors(control: string): string {
		const errors = [];
		if (Object.is('phoneNumber', control)) {
			if (this.form.controls[control].hasError('required')) {
				errors.push(this.INDRA_getTranslation('bookingPayment.text.phonenumberRequired'));
			}
		}
		return errors.join('; ');
	}
	
	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_submitPayment() {

		const operationID = this.paymentInfoService.getPaymentOperationID();

		const totalFlightPrice = this.paymentInfoService.getTotalFlightPrice();
		const cashPrice = this.flightPriceService.INDRA_convertToCorrectDecimalPlace(totalFlightPrice.cash.toString());
		const currency = totalFlightPrice.currency;

		let request = {
			deviceChannel: 'browser',
			sessionId: this.storage.get('token'),
			// merchantAccount: this.merchantAccount,
			currency: currency,
			amount: +(cashPrice),
			pnr:  this.storage.get('bookingPnr'),
			paymentMethodCode: PAYMENT_METHOD_PRP_MB_WAY,
			idOperation: operationID,
			phoneNumber: parseInt(this.form.controls['phoneNumber'].value, 10),
			phoneCountry: 351 // 351
		};

		if (totalFlightPrice && totalFlightPrice.miles) {
			request['points'] = totalFlightPrice.miles;
		}
		
		const userData = this.storage.get('userData');
		if (userData) {
			request['flyTapId'] = userData.airlineID;
		}
		
		const paymentSub = this.indraPaymentService.INDRA_paymentPRP(request).subscribe((res) => {
			if (res && (res.status === '200' || res.status === '211') && res.data && res.data.statusBook) {
				const paymentInfo: Payment = {
					name: '',
					time: new Date(),
					status: 'pending',
					method: 'mb_way',
					details: {
						mb_way: {
							paymentReference: res.data.paymentReference,
							pnr: res.data.pnr,
							phoneNumber: `+351 ${request.phoneNumber}`,
							entityCode: res.data.entityCode,
							transactionIdentifier: res.data.transactionIdentifier,
							paymentTimeLimit: res.data.paymentTimeLimit,
							amount: cashPrice,
							currency: currency,
							status: res.data.statusBook
						}
					}
				};
				this.paymentInfoService.setPaymentInfo(paymentInfo);
				this.paymentInfoService.setPRPPaymentResult(PRP_PAYMENT_RESULT.SUCCESS);
			} else if (res.status === '400' && res.errors && res.errors.length && res.errors.some(err => err.code === '34' &&
				err.desc === "Error PNR paid IBE")) {
				this.paymentInfoService.setPRPPaymentResult(PRP_PAYMENT_RESULT.PAID_ERROR);

			} else {
				if (res && res.data && res.data.idOperation) {
					this.paymentInfoService.setPaymentOperationID(res.data.idOperation);
					this.storage.set('idOperation', res.data.idOperation);
				}
				this.paymentInfoService.setPRPPaymentResult(PRP_PAYMENT_RESULT.ERROR);
			}
		}, 
		(error) => {
			this.paymentInfoService.setPRPPaymentResult(PRP_PAYMENT_RESULT.TECHNICAL_ERROR);
		});
		
		this.allSubs.push(paymentSub);
	}
	
	INDRA_handleBookingTicketConditions() {
		this.sidebarService.openSidebar(['booking-ticket-conditions']);
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ? sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ? sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
        return window.open(urlNavigate);
    }
}
